import {
  GET_LIST_DUNONHANVAY,
  GET_LIST_DUNONHANVAY_SUCCESS,
  GET_LIST_DUNONHANVAY_FAILURE,
} from "../../actions/DuNoNhanVay/actionTypes";

const initialState = {
  List: [],
  TongHopDong: 0,
  TongDuNo: 0,
  TongBanGhi: 0,
};
const getListDuNoNhanVay = (state, action) => ({
  ...state,
  getListDuNoNhanVayLoading: true,
});

const getListDuNoNhanVaySuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    TongHopDong: action.payload.TongHopDong,
    TongDuNo: action.payload.TongDuNo,
    TongBanGhi: action.payload.TongBanGhi,
    getListDuNoNhanVayLoading: false,
  };
};

const getListDuNoNhanVayFailed = (state, action) => ({
  ...state,
  getListDuNoNhanVayLoading: false,
  List: [],
});
export const listDuNoNhanVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DUNONHANVAY:
      return getListDuNoNhanVay(state, action);
    case GET_LIST_DUNONHANVAY_SUCCESS:
      return getListDuNoNhanVaySuccess(state, action);
    case GET_LIST_DUNONHANVAY_FAILURE:
      return getListDuNoNhanVayFailed(state, action);
    default:
      return state;
  }
};

export default listDuNoNhanVayReducer;
